export const errorMessageProps = {
    tag: "p",
    classList: "error-message",
    content: "Search result not successful. Enter the correct movie name",
    attrs: [
        {
            name: "href",
            value: "/"
        }
    ]
};